<div  id="icone" class="filterIcon-close icon-container" aria-hidden="true">
    <div id="bar1" class="bar bar1-close">
      <div class="circle circle-close" style="left:30%"></div>
    </div>

    <div id="bar2" class="bar bar2-close">
      <div class="circle circle-close" style="left:60%"></div>
    </div>

    <div class="bar">
      <div class="circle" style="left:10%"></div>
    </div>
</div>